/* eslint-disable react-hooks/rules-of-hooks */
import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { useFieldValue, useFormikContext } from "formik";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { CADataPoints } from "../models/flexible/ca-data-points";
import { FlexControlProps } from "../models/flexible/flex-field-controller";
import { isEmptyValue } from "../utils/is-empty-value";
import { GeneralFieldController } from "./general-field-controller";

function ResetRelatedFieldsEffect() {
	const { setFieldValue, values } = useFormikContext<CADataPoints>();
	useEffect(() => {
		if (values.patientEnrolledInTreatment) {
			if (values.discontinuationDate) {
				setFieldValue(AttributeIdentifiers.DiscontinuationDate, "");
			}

			if (values.reasonForDiscontinuation) {
				setFieldValue(AttributeIdentifiers.ReasonForDiscontinuation, null);
			}
		}
	}, [setFieldValue, values.discontinuationDate, values.patientEnrolledInTreatment, values.reasonForDiscontinuation]);

	return null;
}

export class PatientEnrolledInTreatmentFieldController extends GeneralFieldController {
	override mapInitialValue(value: unknown): unknown {
		return !this.parent.context.flexEntity ? true : value;
	}

	override createValidationRule(initialData: unknown, translation: (key: string) => string): Yup.AnySchema {
		return (super.createFieldValidationRuleByDataType(translation) as Yup.BooleanSchema).when(
			AttributeIdentifiers.ResponseReceived,
			(responseReceived: boolean, schema: Yup.BooleanSchema) => (responseReceived ? schema.required() : schema)
		);
	}

	renderBeforeContent(): React.ReactElement {
		return this.parent.context.isEditable ? <ResetRelatedFieldsEffect /> : <></>;
	}

	override useControlProps(): FlexControlProps {
		const [responseReceived] = useFieldValue(AttributeIdentifiers.ResponseReceived);
		const { t } = useTranslation();

		return {
			controlType: "combo",
			options: [
				{ label: t("yes"), value: true },
				{ label: t("no"), value: false },
			],
			disabled: !isEmptyValue(responseReceived) && !responseReceived,
		};
	}
}
